function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: "1504px",
    viewBox: "0 -223.316 1920 1527.316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 938.553 326.402 C 1097.489 343.45 1140.149 299.128 1187.619 257.791 C 1235.089 216.454 1277.749 100.113 1399.089 118.864 C 1520.419 137.615 1642.289 77.526 1670.159 -26.03 C 1698.019 -129.587 1835.359 -114.34 1941.219 -170.924 L 1941.219 1314.664 L -106.781 1314.664 L -106.781 1022.445 C -93.981 919.324 157.753 933.249 273.486 909.391 C 389.219 885.524 319.647 827.929 406.819 772.161 C 493.991 716.4 599.886 775.789 599.886 686.507 C 599.886 597.226 629.752 511.781 719.886 511.781 C 810.02 511.781 779.619 309.357 938.553 326.402 L 938.553 326.402 Z",
    fill: "#FEFEFE",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.b523ebd9eccef1e012237488f4ea4df7.svg";
export { ForwardRef as ReactComponent };